export default function() {
    return {
        isLightboxOpen: false,
        activeImageIndex: 0,
        touchStartX: 0,
        touchEndX: 0,
        isSwiping: false,
        swipeThreshold: 50,
        images: [],
        isLoading: false,
        
        init() {
            // Ensure images are properly loaded from data attribute
            // Load both full-size images and thumbnails
            this.images = [];
            this.thumbnails = [];
            
            if (this.$el.dataset.images) {
                try {
                    this.images = JSON.parse(this.$el.dataset.images);
                    this.thumbnails = this.$el.dataset.thumbnails ? 
                        JSON.parse(this.$el.dataset.thumbnails) : 
                        this.images;
                } catch (e) {
                    this.images = [];
                    this.thumbnails = [];
                }
            }
            
            // Create a portal container for the lightbox if it doesn't exist
            if (!document.getElementById('lightbox-portal')) {
                const portal = document.createElement('div');
                portal.id = 'lightbox-portal';
                document.body.appendChild(portal);
            }
        },
        
        next() {
            if (this.activeImageIndex < this.images.length - 1) {
                this.isLoading = true;
                this.activeImageIndex++;
            }
        },
        
        prev() {
            if (this.activeImageIndex > 0) {
                this.isLoading = true;
                this.activeImageIndex--;
            }
        },
        
        close() {
            this.isLightboxOpen = false;
            document.body.classList.remove('overflow-hidden');
        },
        
        open(index = 0) {
            if (!this.images || this.images.length === 0) {
                return;
            }
            
            this.isLoading = true;
            this.activeImageIndex = index;
            this.isLightboxOpen = true;
            document.body.classList.add('overflow-hidden');
        },
        
        handleTouchStart(e) {
            this.touchStartX = e.touches[0].clientX;
            this.isSwiping = true;
        },
        
        handleTouchMove(e) {
            if (!this.isSwiping) return;
            e.preventDefault();
            this.touchEndX = e.touches[0].clientX;
        },
        
        handleTouchEnd() {
            if (!this.isSwiping) return;
            const swipeDistance = this.touchEndX - this.touchStartX;
            
            if (Math.abs(swipeDistance) >= this.swipeThreshold) {
                if (swipeDistance > 0 && this.activeImageIndex > 0) {
                    this.prev();
                } else if (swipeDistance < 0 && this.activeImageIndex < this.images.length - 1) {
                    this.next();
                }
            }
            
            this.isSwiping = false;
            this.touchStartX = 0;
            this.touchEndX = 0;
        },
        
        imageLoaded() {
            this.isLoading = false;
        }
    };
}
